import React from 'react';

import GeneralIssueForm from './GeneralIssueForm';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function GeneralIssueUpsertModal(props) {
    const close = () => {
        props.onClose();
        props.modal.hide();
    };

    const onCreated = () => {
        close();
        props.onCreated();
    };

    return (
        <Modal id={props.id} modal={props.modal}>
            <ModalHeader title={props.issue ? $t('Edit {{name}}', { name: props.issue.description }) : $t('Add New Issue')} close={close}></ModalHeader>
            <div className="tw-rounded-b">
                {props.isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div className="modal__form-container">
                        <GeneralIssueForm
                            currentVenue={props.currentVenue}
                            allowVenueSelection={props.allowVenueSelection}
                            datasets={props.datasets}
                            storeUrl={props.storeUrl}
                            updateUrl={props.updateUrl}
                            issue={props.issue}
                            onSuccess={onCreated}
                            onCancel={close}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
}
